import * as Yup from "yup";

export const LoanWidgetConfigSchema = Yup.object({
  form: Yup.object({
    title: Yup.string().optional(),
    benefitText: Yup.string().optional(),
    ctaText: Yup.string().optional(),
  }).optional(),
  result: Yup.object({
    title: Yup.string().optional(),
  }).optional(),
}).required(
  "Loan widget config is required to render the widget; its options are optional",
);

export type LoanWidgetConfig = Yup.InferType<typeof LoanWidgetConfigSchema>;
